import {Text, Html, ContactShadows, PresentationControls, Float, Environment, useGLTF, OrbitControls } from '@react-three/drei'
import { Suspense, useState, useRef, useEffect } from 'react';
import { useFrame, useThree  } from "@react-three/fiber"
import { Vector3 } from 'three';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons'

export default function Experience()
{
    // const computer = useGLTF('https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/macbook/model.gltf')
    // const computer = useGLTF('/models/scene.gltf')
    const computer = useGLTF('/models/AKMonitor.gltf')
    const computer2 = useGLTF('/models/AKMonitor2.gltf')
    const { width } = useWindowSize();
    // console.log(computer.scene)

    // Check render loop
    // console.log("Render loop");
    
    const { camera } = useThree();
    const [moveCamera, setMoveCamera] = useState(false);
    const [focus, setFocus] = useState(false);
    const targetPosition = new Vector3(0, 0.95, 0.9); // Define the target position
    
    const currentLookAt = useRef(new Vector3(0, 0, 0)); // Initial look at (0, 0, 0)
    const targetLookAt = new Vector3(0, 0.8, 0); // New target look at (0, 1, 0)n


    const isSafari = () => {
        const userAgent = navigator.userAgent;
        console.log("User Agent: ", userAgent);
        // Check if the browser is Safari and the platform is iOS
        // return /Safari/.test(userAgent) && /iPhone|iPad|iPod/.test(userAgent) && !/CriOS/.test(userAgent) && !/FxiOS/.test(userAgent);
        // return /iPhone|iPad|iPod/.test(userAgent);
        // return /Safari/.test(userAgent);
        return false;
      };
    
    const [isSafariBrowser, setIsSafariBrowser] = useState(false);

    useEffect(() => {
        setIsSafariBrowser(isSafari());
        // console.log("Is Safari: ", isSafari());
    }, []);

    const safariStyle = {
        top: '-125px',
      };

    function CameraController() {
        const { camera } = useThree();
        const ref = useRef();
    
        useEffect(() => {
            const handleKeyDown = (event) => {
                if (event.key === "Enter") {
                    setFocus(true); // Start the animation when Enter is pressed
                    setMoveCamera(true); // Start the animation when Enter is pressed
                }
                if (event.key === "Escape" || event.keyCode === 27) {
                    console.log("ESC pressed");
                    setFocus(false); // Start the animation when Enter is pressed
                    setMoveCamera(true); // Start the animation when Enter is pressed
                }
            };
    
            window.addEventListener('keydown', handleKeyDown);
    
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }, []);
    
        useFrame((state, delta) => {


            if (moveCamera) {

                if (focus) {
                    // Interpolate the camera position
                    camera.position.lerp(targetPosition, delta * 0.5);
        
                    // Smoothly interpolate the look at position
                    currentLookAt.current.lerp(targetLookAt, delta * 1.0); // Adjust the 0.5 to control the speed
                    camera.lookAt(currentLookAt.current);
                    
        
                    // Stop the animation when close enough to both targets
                    if (camera.position.distanceTo(targetPosition) < 0.01 && currentLookAt.current.distanceTo(targetLookAt) < 0.01){
                        camera.position.copy(targetPosition);
                        camera.lookAt(targetLookAt);
                        setMoveCamera(false);
                    }
                }
                
                if (!focus) {

                    // Return to the original position
                    camera.position.lerp(new Vector3(-3, 1.5, 4), delta * 0.5);

                    // Return to the original look at position
                    currentLookAt.current.lerp(new Vector3(0, 0, 0), delta * 0.5);
                    camera.lookAt(currentLookAt.current);

                    // Stop the animation when close enough to both targets
                    if (camera.position.distanceTo(new Vector3(-3, 1.5, 4)) < 0.01 && currentLookAt.current.distanceTo(new Vector3(0, 0, 0)) < 0.01){
                        camera.position.copy(new Vector3(-3, 1.5, 4));
                        camera.lookAt(new Vector3(0, 0, 0));
                        setMoveCamera(false);
                    }
                }

            }
        });
    
        return null;
    }

    const handleClick = () => {
        console.log("Primitive model clicked!");
        // Additional actions can be triggered here
    };


    const clickedOnTheMonitor = () => {  
        console.log("Clicked on the monitor");
        if(!focus){
            setFocus(true);
            setMoveCamera(true);
        }else{
            setFocus(false);
            setMoveCamera(true);
        }
    }

    function useWindowSize() {
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
    
        useEffect(() => {
            function handleResize() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
    
            window.addEventListener('resize', handleResize);
    
            // Call handler right away so state gets updated with initial window size
            handleResize();
    
            // Remove event listener on cleanup
            return () => window.removeEventListener('resize', handleResize);
        }, []); // Empty array ensures that effect is only run on mount and unmount
    
        return windowSize;
    }

    function CameraAdjuster() {
        const { camera } = useThree();
        const { width } = useWindowSize();
    
        // console.log(camera)
        useEffect(() => {
            if (width <= 800) {
                // Set camera position for narrower screens
                camera.position.set(-6, 4.25, 8);
                
            }else{
                
            }
    
            // This will cause the camera to update its matrix in the next frame
            camera.updateProjectionMatrix();
        }, [width, camera]); // Depend on width and camera
    
        return null;
    }

    

    return <>
                <CameraAdjuster />
                <CameraController />
                
                <Environment preset="city" />

                <color args={ [ '#16192E' ] } attach="background"/>

                {/* <OrbitControls makeDefault /> */}
                

                

                    

                    {/* <rectAreaLight
                        width={ 2.5 }
                        height={ 1.65 }
                        intensity={ 65 }
                        color={ 'white' }
                        rotation={ [ - 0.1, Math.PI, 0 ] }
                        position={ [ 0, 0.55, - 1.15 ] }
                    /> */}

                        {/* <primitive 
                            object={ computer.scene } 
                            scale={ [ 1,1,1 ] }
                            position={ [ 0, -0.25, -2 ] }
                            onClick={(e) => clickedOnTheMonitor()}
                        >
                            <Html
                            transform
                            wrapperClass="htmlScreen"
                            distanceFactor={ 1 }
                            position={ [ 0, 0.93, 0.8 ] }
                            rotation-x={ - 0.06 }
                            >
                                
                                <iframe src="https://anthonyk-win-xp-portfolio.vercel.app/" />
                            </Html>
                        </primitive> */}

                        

                        {width > 800 ? (
                            // <>
                            // <Text
                            //     font="./Ubuntu-Medium.ttf"
                            //     fontSize={ 0.8 }
                            //     position={ [ 2, 0.75, 0.75 ] }
                            //     rotation-y={ - 1.25 }
                            //     maxWidth={ 2 }
                            // >
                            //     Anthony Ko
                            // </Text>
                            // <primitive 
                            // object={ computer.scene } 
                            // scale={ [ 1,1,1 ] }
                            // position={ [ 0, -0.25, -2 ] }
                            // onClick={(e) => clickedOnTheMonitor()}
                            // >
                            //     <Html
                            //     transform
                            //     wrapperClass="htmlScreen"
                            //     distanceFactor={ 0.5 }
                            //     position={ [ 0, 0.93, 0.8 ] }
                            //     rotation-x={ - 0.06 }
                            //     >
                                    
                            //         <iframe src="https://anthonyk-win-xp-portfolio.vercel.app/" />
                            //     </Html>
                            // </primitive>
                            // </>

                            <>

                            <Html fullscreen>
                                <div className='text-container'>
                                    <div className="blinking-text">Click The Monitor To Begin</div>
                                </div>
                            </Html>

                            <Float rotationIntensity={ focus ? 0 : 0.5 } floatIntensity={focus ? 0 : 0.5}>

                            <PresentationControls
                                global
                                // rotation={ [0.13, 0.1, 0] }
                                polar={ [ - 0.4, 0.2 ] }
                                azimuth={ [ - 1, 0.75 ] }
                                config={ { mass: 2, tension: 400 } }
                                snap={ { mass: 4, tension: 400 } }
                            >
                            <Text
                                font="./Ubuntu-Medium.ttf"
                                fontSize={ 0.8 }
                                position={ [ 2, 0.75, 0.75 ] }
                                rotation-y={ - 1.25 }
                                maxWidth={ 2 }
                            >
                                Anthony Ko
                            </Text>

                            <Text
                                font="./Roboto-Thin.ttf"
                                fontSize={ 0.2 }
                                position={ [ 2, -0.3, 0 ] }
                                rotation-y={ - 1.25 }
                                maxWidth={ 2 }
                            >
                                Software Developer
                            </Text>

                            

                                <primitive 
                                object={ computer.scene } 
                                scale={ [ 1.5,1.5,1.5] }
                                position={ [ 0, -0.9, -3 ] }
                                onClick={(e) => clickedOnTheMonitor()}
                                >
                                    <Html
                                    transform
                                    wrapperClass="htmlScreen"
                                    distanceFactor={ 0.5 }
                                    position={ [ 0, 0.93, 0.8 ] }
                                    rotation-x={ - 0.06 }
                                    >
                                        
                                        <iframe src="https://winxp.anthonyk.net/" />
                                    </Html>
                                </primitive>

                                

                            </PresentationControls>

                            <ContactShadows 
                                    position-y={ - 2 }
                                    opacity={ 0.35 }
                                    scale={ 8 }
                                    blur={ 2.4 }
                                />

                                </Float>
                            </>

                        ) : (
                            <>
                            
                            <PresentationControls
                                global={ true }
                                polar={ [ - 0.4, 0.2 ] }
                                azimuth={ [ - 2, 0.75 ] }
                                // config={ { mass: 2, tension: 400 } }
                                // snap={ { mass: 4, tension: 400 } }
                                enabled={true}
                                speed={1}
                            >
                                
                            <Text
                                font="./Ubuntu-Medium.ttf"
                                fontSize={ 0.8 }
                                position={ [ 0, -0.45, 0 ] }
                                maxWidth={ 2 }
                                rotation-y={ - 1 }
                                textAlign='center'
                            >
                                Anthony Ko
                            </Text>

                            <Text
                                font="./Roboto-Thin.ttf"
                                fontSize={ 0.25 }
                                position={ [ 0, -1.4, 0 ] }
                                rotation-y={ - 1 }
                                maxWidth={ 5 }
                            >
                                Software Developer
                            </Text>
                            
                                <primitive 
                                object={ computer2.scene.clone() } 
                                scale={ [ 2,2,2 ] }
                                position={ [ 0, 1, -0.5 ] }
                                >
                                    {/* <Html
                                    transform
                                    distanceFactor={ 0.5 }
                                    position={ [ 0, 0.93, 0.8 ] }
                                    rotation-x={ - 0.06 }
                                    >
                                        <div className='monitor-iframe'>
                                        <iframe className="iframe-fixed-size" src="https://anthonyk-win-xp-portfolio.vercel.app/" />
                                        </div>
                                    </Html> */}


                                    {/* <Html
                                    fullscreen
                                    transform
                                    wrapperClass="htmlScreen"
                                    distanceFactor={ 0.5 }
                                    position={ [ 0, 0.93, 0.8 ] }
                                    rotation-x={ - 0.06 }
                                    >
                                        
                                        <iframe style={isSafariBrowser ? safariStyle : {}} src="https://winxp.anthonyk.net/" />
                                    </Html> */}
                                </primitive>

                                </PresentationControls>
                                <>
                                <Html fullscreen>
                                    <div className='text-container-mobile'>
                                        <div className="blinking-text-mobile">Please visit on a desktop or laptop to enjoy all features of this website :)</div>
                                        <div className='button-container'>
                                            <button className="button-icon-container" onClick={() => window.location.href = "http://anthonyk.net"}>
                                                <FontAwesomeIcon className='button-icon' icon={faFolderOpen} style={{color: "#FFD43B",}}/>
                                                My Documents
                                            </button>
                                        </div>
                                    </div>
                                    
                                </Html>
                                </>
                            </>
                        )}
                        
    </>
}